var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,57.5c-0.5,0-1.1-0.1-1.5-0.4c-1.2-0.6-1.9-2-1.8-3.4v0l6.2-49.9c0.2-1.3,1-2.3,2.2-2.7 c1.2-0.4,2.5-0.1,3.4,0.8l35.4,35.9c1,1,1.2,2.5,0.6,3.7c-0.6,1.3-1.9,2-3.3,1.9l-22.3-1.9l-16.7,15C30.8,57.3,30,57.5,29.2,57.5z  M36.3,7l-5.4,44l14.6-13.1c0.7-0.6,1.6-0.9,2.5-0.8l19.5,1.6L36.3,7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,92.2l0.7-1.2c0.9,0.7,2.4,1.3,4,1.3c2.1,0,3-0.7,3-1.8c0-2.9-7.3-0.6-7.3-5.1c0-1.8,1.6-3.2,4.5-3.2 c1.5,0,3,0.4,4,1.1l-0.7,1.2c-1-0.7-2.2-1-3.3-1c-2,0-2.9,0.8-2.9,1.9c0,3,7.3,0.8,7.3,5.1c0,2-1.7,3.2-4.7,3.2 C14.4,93.6,12.6,93,11.6,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.6,92.8c-0.6,0.5-1.5,0.8-2.4,0.8c-2.1,0-3.3-1.2-3.3-3.3v-6.8h-2v-1.3h2v-2.5h1.5v2.5h3.4v1.3h-3.4v6.7 c0,1.3,0.7,2.1,2,2.1c0.6,0,1.2-0.2,1.7-0.6L29.6,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,82.2v11.3h-1.5v-2.1c-0.8,1.4-2.3,2.2-4.1,2.2c-2.9,0-4.8-1.6-4.8-4.8v-6.5h1.5v6.4 c0,2.4,1.2,3.6,3.4,3.6c2.4,0,3.8-1.5,3.8-4.1v-5.9H42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,77.5v15.9h-1.5v-2.2c-0.9,1.5-2.5,2.3-4.4,2.3c-3.2,0-5.6-2.3-5.6-5.7c0-3.4,2.4-5.7,5.6-5.7 c1.8,0,3.3,0.8,4.3,2.2v-6.8H57.1z M55.6,87.8c0-2.6-1.8-4.4-4.2-4.4c-2.4,0-4.2,1.8-4.2,4.4c0,2.6,1.8,4.4,4.2,4.4 C53.8,92.2,55.6,90.4,55.6,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,78.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1c0,0.6-0.5,1.1-1.1,1.1C61.5,79.7,61,79.2,61,78.6z  M61.4,82.2h1.5v11.3h-1.5V82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,87.8c0-3.3,2.4-5.7,5.7-5.7s5.7,2.4,5.7,5.7c0,3.3-2.4,5.7-5.7,5.7S66,91.1,66,87.8z M75.9,87.8 c0-2.6-1.8-4.4-4.2-4.4c-2.4,0-4.2,1.8-4.2,4.4c0,2.6,1.8,4.4,4.2,4.4C74.1,92.2,75.9,90.4,75.9,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,92.2l0.7-1.2c0.9,0.7,2.4,1.3,4,1.3c2.1,0,3-0.7,3-1.8c0-2.9-7.3-0.6-7.3-5.1c0-1.8,1.6-3.2,4.5-3.2 c1.5,0,3,0.4,4,1.1l-0.7,1.2c-1-0.7-2.2-1-3.3-1c-2,0-2.9,0.8-2.9,1.9c0,3,7.3,0.8,7.3,5.1c0,2-1.7,3.2-4.7,3.2 C81.7,93.6,79.9,93,79,92.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudios);
export default __webpack_public_path__ + "static/media/studios.8873f1cb656329729102c02637113997.svg";
export { ForwardRef as ReactComponent };